import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import PageContainer from "../layouts/PageContainer";
import AppCircularProgress from "../components/common/AppCircularProgress";
import SequenceCard from "../components/sequences/SequenceCard";
import { getSequences } from "../redux/actions/sequenceActions";
import PageError from "../components/common/PageError";

const SequencesPage = () => {
  const dispatch = useDispatch();
  const { sequences, loadingSequences, errorLoadingSequences } = useSelector(
    (state) => state.sequence,
  );

  const fetchSequences = useCallback(() => {
    dispatch(getSequences());
  }, [dispatch]);

  useEffect(() => {
    fetchSequences();
  }, [fetchSequences]);

  const renderContent = () => {
    if (loadingSequences) return <AppCircularProgress />;
    if (errorLoadingSequences)
      return (
        <PageError error={errorLoadingSequences} onClick={fetchSequences} />
      );
    if (!sequences || sequences.length === 0)
      return (
        <Typography mt={5} textAlign="center">
          No sequences found.
        </Typography>
      );

    return (
      <Grid container spacing={3}>
        {sequences.map((seq) => (
          <Grid item key={seq.id} xs={12} sm={6} md={4} lg={3}>
            <SequenceCard sequence={seq} />
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <PageContainer
      title="Document Sequences"
      subtitle="View the current numbering sequences for all system documents."
    >
      {renderContent()}
    </PageContainer>
  );
};

export default SequencesPage;
